const sections = [
  {
    h: "Introduction",
    b: [
      "Blessings Connection LLC (\"we\", \"our\", or \"us\") respects your privacy and is committed to protecting the personal information you share with us.",
      "This Privacy Policy explains what information we collect, how we use it, and the choices you have regarding your information when you use our website or place an order with us.",
    ],
  },
  {
    h: "Information We Collect",
    b: [
      "Contact information such as your name, email address, shipping address, and phone number when you place an order or create an account.",
      "Order and transaction details, including the items purchased, order total, and delivery information.",
      "Account credentials, including your email and a securely hashed version of your password. We never store passwords in plain text.",
      "Communications you send us, such as customer support emails and product enquiries.",
    ],
  },
  {
    h: "How We Use Your Information",
    b: [
      "To process and fulfill your orders and to communicate with you about your purchases.",
      "To send transactional messages such as order confirmations, shipping updates, password resets, and customer support responses.",
      "To respond to your enquiries and provide customer support.",
      "To improve our website, catalog, and services.",
      "To comply with legal obligations and enforce our terms.",
    ],
  },
  {
    h: "Payment Information",
    b: [
      "Payments are processed by our payment provider, Stripe. We do not receive, store, or have access to your full payment card details.",
      "Only limited transaction information, such as the last four digits of the card or the payment status, is shared with us for order management purposes.",
    ],
  },
  {
    h: "Sharing of Information",
    b: [
      "We do not sell, rent, or trade your personal information.",
      "We share information only with trusted service providers who help us operate our business, including our payment processor (Stripe) and our email delivery provider (Resend). These providers are contractually required to protect your information.",
      "We may disclose information when required by law, regulation, or valid legal process.",
    ],
  },
  {
    h: "Cookies and Tracking",
    b: [
      "We use essential first-party cookies to keep you signed in and to remember the contents of your cart.",
      "We do not use advertising trackers or third-party retargeting pixels.",
    ],
  },
  {
    h: "Data Retention",
    b: [
      "We retain order and account information for as long as necessary to provide our services, comply with our legal obligations, resolve disputes, and enforce our agreements.",
    ],
  },
  {
    h: "Your Rights",
    b: [
      "You may request access to, correction of, or deletion of the personal information we hold about you by contacting our customer support team.",
      "Password reset links are single-use and expire within one hour of being issued.",
    ],
  },
  {
    h: "Security",
    b: [
      "We use industry-standard measures to protect your personal information, including encrypted connections (HTTPS) and secure password storage.",
      "No online service can be guaranteed to be completely secure. If you become aware of any suspected unauthorized access to your account, please contact us immediately.",
    ],
  },
  {
    h: "Changes to This Policy",
    b: [
      "We may update this Privacy Policy from time to time. When we do, we will revise the \"Last Updated\" date at the top of this page.",
    ],
  },
];

export default function Privacy() {
  const updated = "December 2025";
  return (
    <div className="pt-28 md:pt-32 pb-20 bg-[#F9F6F0]" data-testid="privacy-page">
      <div className="max-w-[800px] mx-auto px-6">
        <h1 className="text-3xl md:text-4xl font-semibold text-slate-900 text-center mb-3" data-testid="privacy-title">
          Privacy Policy
        </h1>
        <p className="text-sm text-slate-500 text-center mb-10" data-testid="privacy-eyebrow">
          Last Updated: {updated}
        </p>

        <div className="space-y-6 text-base leading-relaxed text-slate-700">
          {sections.map((s, idx) => (
            <section key={s.h} data-testid={`privacy-section-${String(idx + 1).padStart(2, "0")}`}>
              <h2 className="text-xl font-medium mt-8 mb-3 text-slate-900">{s.h}</h2>
              <div className="space-y-3">
                {s.b.map((p, i) => <p key={i}>{p}</p>)}
              </div>
            </section>
          ))}

          <section data-testid="privacy-section-contact">
            <h2 className="text-xl font-medium mt-8 mb-3 text-slate-900">Contact Us</h2>
            <p>If you have any questions about this Privacy Policy or how we handle your information, please contact:</p>
            <div className="mt-3">
              <p className="font-medium text-slate-900">Blessings Connection LLC</p>
              <p>
                Email:{" "}
                <a
                  href="mailto:customerservice@blessingsconnection.com"
                  className="text-slate-900 underline hover:text-[#7A2021]"
                  data-testid="privacy-contact-email"
                >
                  customerservice@blessingsconnection.com
                </a>
              </p>
              <p className="mt-2">Our customer support team aims to respond within 1–2 business days.</p>
            </div>
          </section>

          <div className="border-t border-slate-200 pt-6 mt-10">
            <p className="text-sm text-slate-500">
              Blessings Connection LLC · blessingsconnection.com
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
